import { ReportConstant } from '../constants';
import { RequestAction } from '.';

export const getSalesReport = params =>
  RequestAction.request(ReportConstant.GET_SALES_REPORT, {
    params,
    url: '/api/report/sale',
  }, false);

export const getStocksReport = params =>
  RequestAction.request(ReportConstant.GET_STOCKS_REPORT, {
    params,
    url: '/api/report/stock',
  }, false);

export const setReport = payload => ({
  payload,
  type: ReportConstant.SET_REPORT,
});
